import React, { useState } from 'react';
import { Box, Card, CardContent, TextField, Button, Typography, Alert } from '@mui/material';
import { Link } from 'react-router-dom';
import apiClient from '../api/client';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await apiClient.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f5f5' }}>
      <Card sx={{ width: 400 }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h5" fontWeight={700} mb={1}>Reset password</Typography>

          {sent ? (
            <>
              <Alert severity="success" sx={{ mt: 2 }}>
                If that email is registered, a reset link has been sent. Check your inbox.
              </Alert>
              <Button component={Link} to="/login" fullWidth sx={{ mt: 3 }}>
                Back to sign in
              </Button>
            </>
          ) : (
            <>
              <Typography variant="body2" color="text.secondary" mb={3}>
                Enter your email and we'll send you a link to reset your password.
              </Typography>
              {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
              <Box component="form" onSubmit={submit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField
                  label="Email" type="email" size="small"
                  value={email} onChange={e => setEmail(e.target.value)} required autoFocus
                />
                <Button type="submit" variant="contained" disabled={loading}>
                  {loading ? 'Sending…' : 'Send reset link'}
                </Button>
              </Box>
              <Typography variant="body2" sx={{ mt: 2, textAlign: 'center' }}>
                <Link to="/login" style={{ color: '#1976d2' }}>Back to sign in</Link>
              </Typography>
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
